import { render, staticRenderFns } from "./history-detail.vue?vue&type=template&id=341b9d1e&scoped=true"
import script from "./history-detail.vue?vue&type=script&lang=js"
export * from "./history-detail.vue?vue&type=script&lang=js"
import style0 from "./history-detail.vue?vue&type=style&index=0&id=341b9d1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341b9d1e",
  null
  
)

export default component.exports